import { Option } from '@/data/hikari/option';
import { PhoneInitialiCostData } from '@/@types/json/hikari';

// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

type ChargeDetail = { 回線種別: string; 標準料金: number }[];

export class Phone {
  public id: string;
  public key: string;
  public name: string;
  public initialChargeDetails: PhoneInitialiCostData;
  public monthlyCharge: number;
  public options: Option[];

  // tslint:disable-next-line:max-line-length
  constructor(
    id: string,
    key: string,
    name: string,
    initialChargeDetails: PhoneInitialiCostData,
    monthlyCharge: number,
    options: Option[]
  ) {
    this.id = id;
    this.key = key; // 日本語
    this.name = name;
    this.initialChargeDetails = initialChargeDetails;
    this.monthlyCharge = monthlyCharge;
    this.options = options;
  }

  public initialCharge(entryTypeId: string): number {
    let total = 0;
    for (let costName in this.initialChargeDetails) {
      const cost = _.find(this.initialChargeDetails[costName], [
        '回線種別',
        entryTypeId,
      ]);
      total += cost ? cost['標準料金'] : 0;
    }
    return total;
  }

  public optionMonthlyCharge(optionId: string): number {
    const o = _.find(this.options, (option: Option) => {
      return option.id === optionId;
    });
    return o ? o.monthlyCharge : 0;
  }
}
